<template>
    <div class="div"><h1>Gestion des Congés</h1></div>
</template>
<script>
export default {
    setup() {
        
    },
    data:{
        
    }
}
</script>